import { Layout, Section } from 'layout';
import { OrderDetailsScreen } from 'pages/orders/screens/order-details-screen';
import { OrdersListScreen } from 'pages/orders/screens/orders-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const OrdersPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={OrdersListScreen} />
          <Route path={`${match.url}/details/:code`} component={OrderDetailsScreen} />
          <Route path={`${match.url}/restaurant-details/:id`} component={OrderDetailsScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default OrdersPage;
